import { Method } from 'axios';
import { apiCall } from '@/utility/api/apiUtils';
import {
  API_METHOD_POST,
  API_CREATE_VARIATION,
} from '@/constants/apiConstants';
import { generateHash } from '@/utility/auth/generateHashValue';

export interface CreateVariationPayload {
  title: string;
  description: string;
  date?: string;
  attachments: Array<{
    link: string;
    size: string;
    name: string;
  }>;
  signature: {
    link: string;
    size: string;
    name: string;
  } | null;
  sections: any[];
}

export interface CreateVariationResponse {
  status: 'SUCCESS' | 'ERROR';
  data?: any;
  message?: string;
}

export const createVariation = async (
  jobUuid: string,
  payload: CreateVariationPayload,
): Promise<CreateVariationResponse> => {
  const method: Method = API_METHOD_POST;
  const url = API_CREATE_VARIATION(jobUuid);
  const data = payload;

  // Convert JSON object to string
  const jsonString = JSON.stringify(data);
  const additionalHeaders = {
    hash: generateHash(jsonString),
  };

  try {
    const response = await apiCall({
      method,
      url,
      data,
      headers: additionalHeaders,
    });
    return response; // Return the response data for further use
  } catch (error) {
    throw error; // Re-throw the error to be handled by the caller
  }
};
